<template>
  <main class="content"  >
    <headerCustom :name="translation.NAME" :logo="translation.LOGO" :lang="language" @changeLang="changeLanguage" />
    <section class="container-fluid">
      <!--<b-container fluid>
        <b-row>
          <b-col class="p-0">
            <ButtonComponent text="All Products"
                           variant="primary"
                           href="https://systemico.net/products"
                           icon="arrow-left"
                           class="border-0 rounded-0"
            />
          </b-col>
        </b-row>
      </b-container>-->
      <b-container fluid="xl" class="form">
        <b-row>
          <b-col cols="12" md="6" class="p-0 d-none d-md-block">
            <div class="form__description" :style="'background-image: url('+translation.IMAGE+');'">
              <!--<img :src="$cdn + '/logos/logo-gogoals.png'" alt="Gogoals" title="Gogoals">
              <h2>{{ options[option].title }}</h2>
              <p>{{ options[option].text }}</p>
              <div class="options">
                <button
                  :class="option == 0 ? 'active' : ''"
                  v-on:click="changeOption(0)"
                ></button>
                <button
                  :class="option == 1 ? 'active' : ''"
                  v-on:click="changeOption(1)"
                ></button>
                <button
                  :class="option == 2 ? 'active' : ''"
                  v-on:click="changeOption(2)"
                ></button>
                <button
                  :class="option == 3 ? 'active' : ''"
                  v-on:click="changeOption(3)"
                ></button>
              </div>-->
            </div>
          </b-col>
          <b-col cols="12" md="6" class="p-0">
            <div class="form__content">
              <h1>{{title[language]}}</h1>
              <div class="line"></div>
              <p>
                <h2>{{translation[language].title}}</h2>
                <p>{{translation[language].description}}</p>
              </p>
              <div style="margin:auto;width: 260px;text-align: center;">
                <ButtonGoogleLogin
                      v-if="translation.AUTH['GOOGLE']"
                      :lang="language"
                      variant="secondary"
                      class="text-center"
                      :urlcallback="translation.URLCALLBACK"
                  />
                <ButtonMicrosoftLogin
                    v-if="translation.AUTH['MICROSOFT']"
                    :lang="language"
                    variant="secondary"
                    class="mt-2"
                  />
                <ButtonLinkedInLogin
                  v-if="translation.AUTH['LINKEDIN']"
                  text="Sign in <b>with Linkedin</b>"
                  variant="secondary"
                  class="mt-2"
                />
                <ButtonEmailVerification
                    v-if="translation.AUTH['OTP']"
                    variant="secondary"
                    :lang="language"
                    :channel="2"
                    class="mt-2"
                    type="LOGIN"
                    channelType="EMAIL"
                />
              </div>
              <span>{{policy[language]}}</span>
              <div class="line--2"></div>
              <span class="font-weight-bold" v-html="motivation_create_account[language]"></span>
              <div class="text-center pt-2">
                <ButtonComponent class="pt-2 pb-2" icon="arrow-right-circle-fill" iconPosition="end" :text="create_account[language]" variant="warning" href="/signup" />
              </div>
              <!--<a class="create_account" href="/signup" v-html="create_account[language]"></a>-->
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid="xl">
        <b-row>
            <b-col>
              <div class="content__options">
                <a
                  class="content__link"
                  href="https://systemico.net/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Terms of Use</a
                >
                <a
                  class="content__link"
                  href="https://systemico.net/politics"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Privacy Policy</a
                >
                <a
                  class="content__link"
                  href="https://systemico.net/advice"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Privacy Advice</a
                >
              </div>
            </b-col>
          </b-row>
      </b-container>
    </section>
    <footerCustom />
  </main>
</template>

<script>
import headerCustom from "../components/header.vue";
import footerCustom from "../components/footer.vue";
import ButtonEmailVerification from "../packages/systemico.ui/components/buttons/ButtonEmailVerification.vue";
import ButtonGoogleLogin from "../packages/systemico.ui/components/buttons/ButtonGoogleLogin.vue";
import ButtonLinkedInLogin from "../packages/systemico.ui/components/buttons/ButtonLinkedInLogin.vue";
import FooterSystemicoComponent from "../packages/systemico.ui/components/footers/FooterSystemicoComponent.vue";
import ButtonMicrosoftLogin from "../packages/systemico.ui/components/buttons/ButtonMicrosoftLogin.vue";
import ButtonComponent from "../packages/systemico.ui/components/buttons/ButtonComponent.vue";
import json from "../../../../lang/login.json";
export default {
  name: 'LoginView',
  components: {
    ButtonComponent,
    ButtonMicrosoftLogin,
    FooterSystemicoComponent,
    ButtonLinkedInLogin,
    ButtonGoogleLogin,
    ButtonEmailVerification,
    headerCustom,
    footerCustom,
  },
  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },
  data: function () {
    return {
      translation: json,
      language: 'EN',
      option: 0,
      options: '',
      title: {
        ES: 'Acceso Seguro',
        EN: 'Sign in now'
      },
      policy: {
        ES: 'Cuando creas o accedes a tu cuenta aceptas nuestras políticas y términos.',
        EN: 'When you create an account you accept our policies and terms.'
      },
      motivation_create_account: {
        ES: '¿Listo para empezar?',
        EN: 'Ready to be an user?'
      },
      create_account: {
        ES: '<b>Crea</b> tu <b>cuenta gratis</b>',
        EN: '<b>Create</b> your <b>free account</b>'
      }
    }
  },
  mounted () {
    this.autoChangeOption()
    this.options = this.translation[this.lang].options
  },
  beforeMount() {
    this.language = this.lang
  },
  methods: {
    changeOption: function (option) {
      this.option = option;
    },
    changeLanguage: function (lang) {
      this.language = lang
      this.options = this.translation[this.language].options
    },
    autoChangeOption: function () {
      setTimeout(() => {
        if (this.option == 3) {
          let option = 0
          this.option = option
          this.autoChangeOption()
        } else {
          const option = this.option + 1
          this.option = option
          this.autoChangeOption()
        }
      }, 5000)
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  min-height: 100vh;
  background-color: #f8f9fc;
  font-family: "Quicksand", sans-serif;
  &__section {
    padding: 1rem;
  }
  &__link {
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    color: #4285f4;
    img {
      margin-right: 10px;
    }
  }

  &__options {
    a {
      margin: 10px 0;
      font-size:12px;
      text-align: center;
      display: block;
    }
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {

    &__options {
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        margin: 0 10px;
        text-align: center;
        display: block;
      }
    }
  }
}

.form {
  margin: 5vh auto;
  box-shadow: 0px 3px 12px rgba(34, 37, 44, 0.16);
  border-top:1px solid #dbdee6;
  min-height: 70vh;
  padding: 0;
  /**border-bottom:1px solid #dbdee6;**/

  &__description {
    min-height: 70vh;
    padding: 0px;
    margin:0;
    /**background: transparent linear-gradient(41deg, #171E44 0%, #006DF0 100%) 0% 0% no-repeat padding-box;**/

    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .note{
      border-radius:5px;
      margin:20px;
      display: none;
      h2 {
        margin: 0 0 0px;
        font-family: "Quicksand", sans-serif;
        font-size: 18px;
        font-weight: 700;
        color: #222222;
        text-align: center;
        padding: 5px;
        border-bottom: 2px solid #aaaaaa;
      }

      p {
        font-family: "Quicksand", sans-serif;
        font-size: 16px;
        font-weight: normal;
        color: #444444;
        text-align: center;
        height: 60px;
        margin:0;
        padding: 5px;
      }

      .options {
        margin: 0;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;

        button {
          width: 7px;
          min-width: 7px;
          max-width: 7px;
          height: 7px;
          margin: 0 0.5rem;
          padding: 0;
          border: 1px solid #aaaaaa;
          border-radius: 50%;
          background: transparent;

          &.active {
            background-color: #0b1c98;
          }
        }
      }
    }
  }

  &__content {
    padding: 20px;
    border-radius: 0 0 5px 5px;

    & > h1 {
      margin: 0 0 10px;
      font-size: 1rem;
      font-weight: bold;
      color: #aaaaaa;
      text-align: center;
    }

    & > h2 {
      margin: 0 0 20px;
      font-size: 2rem;
      font-weight: bold;
      color: #4d556e;
      text-align: center;
    }

    .line {
      width: 86px;
      height: 4px;
      margin: 0 auto 30px;
      border-radius: 4px;
      background-color: #dbdee6;
      display: block;
    }

    & > p {
      margin: 0 0 20px;
      font-size: 16px;
      font-weight: normal;
      color: #4d556e;
      text-align: center;
      display: block;
    }

    .line--2 {
      width: 100%;
      height: 2px;
      margin: 0 auto 20px;
      border-radius: 4px;
      background-color: #dbdee6;
      display: block;
    }

    & > span {
      margin: 10px 0 10px;
      font-size: 0.8rem;
      font-weight: normal;
      color: #4d556e;
      text-align: center;
      display: block;
    }

    & > a {
      margin: 0;
      font-size: 16px;
      font-weight: bold;
      color: #4285f4;
      text-align: center;
      display: block;

      span {
        font-weight: lighter;
        color: #4d556e;
      }
    }
  }

  // responsive para dispositivos de tablets en adelante
  @media (min-width: 992px) {
    border-radius: 5px;
    overflow: hidden;
    &__content {
      padding: 40px 50px;
      border-radius: 0;
    }
  }
}
</style>
